import { StackedDetail } from "../StackedDetail";
import { useTranslation } from "react-i18next";
import React from "react";

export const TransportConfirmDetailsSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-flow-row grid-cols-4 grid-rows-[min-content]">
      <StackedDetail labelI18nKey="models.autotractor.jobType">
        {t("models.autotractor.jobTypes.transport")}
      </StackedDetail>
    </div>
  );
};
